module.exports = __webpack_public_path__ + "static/media/male.da0890cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male.png
// module id = 1112
// module chunks = 0